import React from 'react'
import Modal from '@/components/ui/Modal'
import TitleInput from '@/components/ui/TitleInput'
import { ReactComponent as CodeIcon } from '@/assets/icons/code.svg'
import Button from '@/components/ui/Buttons/Button'
import { useForm, usePaste } from './SnippetModal.hooks'
import { Form, Formik } from 'formik'
import classes from './SnippetModal.module.scss'
import { Puff } from '@/components/ui/Loaders'
import { SnippetModalProps } from './SnippetModal.types'
import SnippetEditor from './SnippetEditor'

export const SnippetModal = ({ onClose, config, snippet, onPaste }: SnippetModalProps) => {
  const formikProps = useForm(snippet, onClose)
  const paste = usePaste(onPaste, onClose)

  return (
    <Formik {...formikProps}>
      {({ handleSubmit, values, setFieldValue, handleBlur, isSubmitting }) => (
        <Form>
          <Modal onClose={onClose} isOpen>
            <Modal.Header>
              <div>
                <Modal.Icon>
                  <CodeIcon />
                </Modal.Icon>
                <TitleInput
                  placeholder={'New snippet'}
                  name={'name'}
                  onSave={(name) => setFieldValue('name', name)}
                  onBlur={handleBlur}
                  value={values.name}
                />
              </div>
              <div>
                {/*{snippet && <DeleteButton onClick={remove} isLoading={isDeleteLoading} />}*/}
                <Modal.Close onClick={onClose} />
              </div>
            </Modal.Header>
            <Modal.Content>
              <div className={classes.editor}>
                <SnippetEditor name="code" snippetId={snippet?.id} config={config} />
              </div>
            </Modal.Content>
            <Modal.Footer>
              {snippet && (
                <Button color={'neutral'} onClick={() => paste(values.code)}>
                  Paste snippet in the code
                </Button>
              )}
              <Button
                onClick={() => handleSubmit()}
                disabled={isSubmitting}
                StartIcon={isSubmitting ? <Puff /> : undefined}
              >
                {snippet ? 'Save snippet' : 'Create snippet'}
              </Button>
            </Modal.Footer>
          </Modal>
        </Form>
      )}
    </Formik>
  )
}
